import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Bestellung überprüfen',
    [StepEnum.OrderPayment]: 'Zahlung',
  },
};
